@if (label()) {
  <label [for]="id()" class="block mb-1.5 text-sm font-medium text-heading">
    {{ label() }}@if (required()) {<span class="font-semibold text-danger">*</span>}
  </label>
}

<div class="flex">
  <select
    #inputElement
    [autofocus]="autofocus()"
    [id]="id()"
    [(ngModel)]="selected"
    [disabled]="disabled()"
    [required]="required()"
    class="bg-white border border-gray-300 text-gray-900 text-base sm:text-sm rounded-s-lg focus:ring-brand focus:border-brand block w-full p-2.5 disabled:text-fg-disabled"
  >
    @if (placeholder()) {
      <option value="" hidden>{{ placeholder() }}</option>
    }
    @for (option of options(); track $index) {
      <option [value]="option.value">{{ option.label }}</option>
    }
  </select>

  <button type="button" (click)="onButtonClick()" [disabled]="buttonDisabled()" class="cursor-pointer shrink-0 px-4 py-2.5 disabled:text-fg-disabled disabled:bg-disabled text-sm font-medium text-white bg-brand disabled:border-default border border-brand border-s-0 rounded-e-base hover:bg-brand-strong focus:ring-4 focus:ring-brand-medium focus:outline-none">
    <ng-content />
  </button>
</div>

@if (help()) {
  <p class="text-xs text-body px-2">{{ help() }}</p>
}
